import React from 'react'
import cx from 'classnames'

import { useAppSelector } from '../../hooks'
import { selectCurrentPlayStatus } from '../../selectors/current-play-selectors'
import { MAX_SCORE } from '../../constants/constants'

type Props = {
  playerIndex: number
}
const MovingLaneScore = ({ playerIndex }: Props) => {
  const playStatus = useAppSelector(selectCurrentPlayStatus(playerIndex))
  const { score, runningScoreRank = 'bad' } = playStatus
  const [maxWidth, setMaxWidth] = React.useState(0)
  const [scoreWidth, setScoreWidth] = React.useState(0)
  const setWrapperRef = (elem: HTMLDivElement) => {
    if (elem) {
      setMaxWidth(elem.clientWidth)
    }
  }
  const setScoreRef = (elem: HTMLDivElement) => {
    if (elem) {
      setScoreWidth(elem.clientWidth)
    }
  }
  const padding = 9
  const scoreFactor = ((maxWidth - padding) * score) / MAX_SCORE
  const scorePercentage = -scoreWidth / 2 + scoreFactor
  const style = { left: `${scorePercentage}px` }
  const isMaxed = score > 0 && Math.abs(MAX_SCORE - score) < 0.01
  const classOptions = {
    active: true,
    [`${runningScoreRank || 'none'}`]: true,
    maxed: isMaxed,
  }
  const scoreClassName = cx('scoreView', classOptions)

  return (
    <div className={`lane${playerIndex}`} ref={setWrapperRef}>
      `
      <div style={style} className={scoreClassName} ref={setScoreRef}>
        {score.toFixed()}
      </div>
      <div className="scoreCountersWrapper"></div>
    </div>
  )
}

export default MovingLaneScore
